import { render, staticRenderFns } from "./ApproveRegisterModal.vue?vue&type=template&id=7eb8e544"
import script from "./ApproveRegisterModal.vue?vue&type=script&lang=js"
export * from "./ApproveRegisterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports